import * as React from "react";
import { PageHeader, Grid, Row, Col } from "react-bootstrap"

import { IModelHandler, entitetPath } from "../domene"

import { doPost } from "./Handlinger";
import { Kolonne } from "./Kolonne";

import Models = Gf.Web.Models;

export function side(tittel: string, children: any) {
    return <Grid><Row className="show-grid">
        <Col>
            {tittel ? <PageHeader>{tittel}</PageHeader> : null}
            {children}
        </Col>
    </Row></Grid>;
}

export interface IFocusedField {
    onBlur(): void;
}

export function setCurrentFocusedField(field: IFocusedField) {
    currentFocusedField = field;
}

let currentFocusedField: IFocusedField | undefined;

export function checkBlur() {
    if(currentFocusedField) {
        currentFocusedField.onBlur();
        currentFocusedField = undefined;
    }
}

export function blurInner<TFeltType>(
    entitetType: Gf.Dom.Type.EntitetType | undefined,
    handler: IModelHandler<TFeltType>,
    id: number,
    feltType: TFeltType,
    gammelVerdi: any,
    nyVerdi: any): void {

    handler.setError(`${feltType}`, undefined);
    if ((entitetType === undefined) || (gammelVerdi == nyVerdi)) {
        return;
    }
    const url = `${`/${entitetPath(entitetType)}/Lagre/${id}`}`;
    const endring = {
        FeltType: feltType,
        Verdi: nyVerdi
    } as Models.FeltEndring<TFeltType>;
    const modell = {
        EntitetType: entitetType,
        Id: id,
        Endringer: [endring]
    } as Models.EntitetEndringModell<TFeltType>;
    doPost(url, modell, feltType, handler);
}

function definisjon<TFeltType>(model: Models.EntitetListeModell<TFeltType> | undefined, feltType: TFeltType): Models.FeltDefinisjon<TFeltType> | undefined {
    return model === undefined ? undefined : model.Definisjoner.find(d => d.Felt === feltType);
}

export function kolonne<TFeltType>(model: Models.EntitetListeModell<TFeltType> | undefined, feltType: TFeltType, width: string, navn?: string, høyre?: boolean): Kolonne<TFeltType> {
    const d = definisjon(model, feltType);
    if(d === undefined) {
        throw `Cannot find column ${feltType}`;
    }
    return new Kolonne<TFeltType>(feltType, d, width, navn, høyre);
}

export function klasse<TFeltType>(kolonne: Kolonne<TFeltType>): string {
    return kolonne.høyrejustert ? "rightAlign" : "";
}

function controls<TFeltType>(model: Models.EntitetListeModell<TFeltType>): JSX.Element {
    const length = this.props.Rader.length;
    const offset = this.props.Offset as number;
    const take = this.props.Take as number;
    const end = offset + length;
    const totalCount = this.props.TotalCount as number;
    const pages = Math.floor((totalCount + take - 1) / take);
    const page = Math.floor(offset / take);
    const maxBoxes = 10;
    const boxes = Math.min(pages, maxBoxes);
    const boxOffset = Math.max(page - 5, 0) + 1;
    const numbers = Array.apply(null, {length: boxes}).map(Number.call, Number);
    return (pages >= 2) ? numbers.map((i: number) => <span className="sidevelger">{i + boxOffset}</span>) : null;
}

export function hentData<TFeltType, TModel extends Models.EntitetListeModell<TFeltType>>(model: TModel, rad: Models.ListeRadModell, feltType: TFeltType): any {
    const i = model.Definisjoner.map(d => d.Felt).indexOf(feltType);
    return rad.Verdier[i];
}




// WEBPACK FOOTER //
// ./Scripts/React/Component/components.tsx